import {
    FETCH_RESTAURANT_CONFIG,
    CREATE_POS_TERMINAL,
} from '../types';
import api from '../api';

export const fetchRestaurantConfig = (restId) => {
    return {
        type: FETCH_RESTAURANT_CONFIG,
        payload: api.restaurant.get(restId).config.getConfig(),
    };
};

export const createPosTerminal = (restId, hostName) => {
    return {
        type: CREATE_POS_TERMINAL,
        payload: api.restaurant.get(restId).config.createPosTerminal({ hostName }),
    };
};
